import React from 'react';
import { Element } from 'react-scroll';
import SectionTitle2 from '../../sectionTitle/SectionTitle2';
import { Link } from 'react-router-dom';

const ManufacturingTransformation = () => {
  return (
    <>
      <Element
      name="ManufacturingTransformation"
        className="datatalent-section-gap bg-white"
      >
        <div className="container inner about-feature-list">
          <div className="row g-5">
            <div className="col-12 col-lg-6 mt-0 px-0 px-md-4">
              <SectionTitle2
                classes = "text-left"
                title = "Manufacturing Industry Transformation"
              />
              <p className="mt-4">Edge AI is reshaping industrial operations-from maintenance to energy forecasting and resource planning. Our real-time AI solutions reduce downtime, optimize energy usage, and unlock operational agility.</p>
              <h6 className="mt-5 mb-4">Transformation Highlights</h6>
              <ul>
                <li>From Reactive Fixes → To Predictive Maintenance</li>
                <li>From Centralized Processing → To Edge-Aware Devices</li>
                <li>From Energy Guesswork → To Real-Time Optimization</li>
                <li>From Manual Logs → To Smart Dashboards</li>
              </ul>
              <Link className="edu-btn btn-primary" to="/products/m2m-edge-ai">Discover Edge AI Products</Link>
            </div>
            <div className="col-12 col-lg-6 mt-4 mt-md-0 px-0 px-md-4 d-flex flex-row flex-wrap align-items-center justify-content-center">
              <div className="d-flex flex-row flex-wrap align-items-center justify-content-center">
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-blue p-4">
                    <h5 className="mtsc-heading mb-0">
                      -45%
                    </h5>
                    <small>Equipment Downtime</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-green p-4">
                    <h5 className="mtsc-heading mb-0">
                      +30%
                    </h5>
                    <small>Process Efficiency</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-purple p-4">
                    <h5 className="mtsc-heading mb-0">
                      -25%
                    </h5>
                    <small>Energy Waste</small>
                  </div>
                </div>
                <div className="col-6 p-2">
                  <div className="manufacturing-transformation-stats-card-orange p-4">
                    <h5 className="mtsc-heading mb-0">
                      +40%
                    </h5>
                    <small>Maintenance Forecast Accuracy</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default ManufacturingTransformation;